(($, Drupal, drupalSettings) => {
  Drupal.behaviors.OfficeHeaderToggle = {
    attach: (context, settings) => {

      // save some chars on filesize.
      const smallerQuerySelectorAll = context.querySelectorAll.bind(context);
      const smallerQuerySelector = context.querySelector.bind(context);
      const narrowerSelectList = smallerQuerySelectorAll('select[data-cross-selection-narrower]');
      const select = smallerQuerySelectorAll('.office-booking select');
      const branchSelect = smallerQuerySelector('.office-booking select.branch-select');

      const isAllNone = (els) => {
        var r = true;
        els.forEach( el => {
          if(r && el.value !== 'none'){
            r = false;
          }
        });
        return r;
      }
      const resetEls = (els, exclude) => {
        els.forEach( loop => {
          if( exclude.indexOf(loop) === -1 ){
            loop.value = 'none'
          }
        });
      }


      // On chainpages there is multi select dingel dangel.
      if (narrowerSelectList) {
        narrowerSelectList.forEach( (el) => {

          const narrowerSettings = JSON.parse(el.dataset.crossSelectionNarrower),
          unWrap = (els) => {
            els.forEach( el => {
              var parent = el.parentNode;
              while (el.firstChild) parent.insertBefore(el.firstChild, el);
              parent.removeChild(el);
            });
          },
          wrap = (els) => {
            els.forEach( elem => {
              const div = document.createElement('span');
              div.style.display = '';
              elem.parentElement.insertBefore(div, elem);
              div.appendChild(elem);
            });
          },

          triggerOtherChanges = (e) => {
            const thisSettings = narrowerSettings[e.target.value];

            const fixSettings = key => {
              const keyElement = smallerQuerySelectorAll('.' + key);
              keyElement.forEach( limitSelect => {

                const LimitQueryAll = limitSelect.querySelectorAll.bind(limitSelect);
                const items = LimitQueryAll('span');

                if (items) unWrap( items );

                if (thisSettings[key] !== 'all') {
                  var options = limitSelect.options;

                  for( var i = 0; i < options.length; i++) {

                    if (options[i].value !== 'none' && options[i].value !== 'other' && thisSettings[key].indexOf(options[i].value) == -1){
                      wrap([options[i]]);
                    }
                  }
                }
              });
            }

            Object.keys(thisSettings).forEach( fixSettings );
          }


          el.addEventListener('change', triggerOtherChanges)
        });
      }

      (select && select.forEach( selContainer => selContainer.addEventListener('change', e => {
        var $bookButton = $("button.book",context),
            $headerNotification = $('.header-notification',context),
            chainPage = $bookButton.hasClass('hidden');

        if (e.target.value === 'other') {
          $headerNotification.show();
          resetEls(select, [e.target]);
          $bookButton.hide();
        }
        else if (e.target.value !== 'none') {
          $headerNotification.hide();
          resetEls(select, [e.target, branchSelect]);
          $bookButton.show();
        }
        else {
          $headerNotification.hide();
          if (chainPage) {
            $bookButton.hide()
          }
        }
        if(branchSelect && branchSelect.value === 'none'){
          $bookButton.hide();
        }
        else {
          if(e.target.value ==='none') {
            $bookButton.show();
          }
        }
      })));
    }
  }
})(jQuery, Drupal, drupalSettings);
